export enum UnauthorizedErrorType {
  ACCOUNT_INACTIVE = 'ACCOUNT_INACTIVE',
  AUTH_CONFLICT = 'AUTH_CONFLICT',
  INVALID_AUTH = 'INVALID_AUTH',
  LINK_UNAVAILABLE = 'LINK_UNAVAILABLE',
  LOGIN_KEY_EXPIRED = 'LOGIN_KEY_EXPIRED',
  NOT_AUTHED = 'NOT_AUTHED',
  NO_PROFILE_FOUND = 'NO_PROFILE_FOUND',
}
